import { render } from "./MantenedorUnidades.vue?vue&type=template&id=7e1663b3"
import script from "./MantenedorUnidades.vue?vue&type=script&lang=js"
export * from "./MantenedorUnidades.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__